module.exports = __webpack_public_path__ + "img/zzoe.8a841f98.jpg";